import type { TypedUseSelectorHook } from 'react-redux';
import { useDispatch, useSelector } from 'react-redux';

import type { PrivacyCenterRootState } from '@main/privacy-center/src/reducer';
import type { PrivacyCenterDispatch } from '@main/privacy-center/src/store';

// TODO: https://transcend.height.app/T-556

// Use throughout your app instead of plain `useDispatch` and `useSelector`
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const usePrivacyCenterDispatch = () =>
  useDispatch<PrivacyCenterDispatch>();
export const usePrivacyCenterSelector: TypedUseSelectorHook<PrivacyCenterRootState> =
  useSelector;
